/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_AtlasInputs */

const en_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Atlas`)
};

const es_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Atlas`)
};

const fr_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Atlas`)
};

const de_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Atlas`)
};

const ja_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: Atlas`)
};

const zh_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：Atlas`)
};

const ar_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: Atlas`)
};

const id_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Atlas`)
};

const it_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Atlas`)
};

const ru_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Atlas`)
};

const pt_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Atlas`)
};

const ko_eg_atlas = /** @type {(inputs: Eg_AtlasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 아틀라스`)
};

/**
* | output |
* | --- |
* | "e.g. Atlas" |
*
* @param {Eg_AtlasInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_atlas = /** @type {((inputs?: Eg_AtlasInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_AtlasInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_atlas(inputs)
	if (locale === "es") return es_eg_atlas(inputs)
	if (locale === "fr") return fr_eg_atlas(inputs)
	if (locale === "de") return de_eg_atlas(inputs)
	if (locale === "ja") return ja_eg_atlas(inputs)
	if (locale === "zh") return zh_eg_atlas(inputs)
	if (locale === "ar") return ar_eg_atlas(inputs)
	if (locale === "id") return id_eg_atlas(inputs)
	if (locale === "it") return it_eg_atlas(inputs)
	if (locale === "ru") return ru_eg_atlas(inputs)
	if (locale === "pt") return pt_eg_atlas(inputs)
	return ko_eg_atlas(inputs)
});